import {gql} from '@apollo/client';

export const GET_MARKER_COUNT_BY_ACCOUNT_ID_AND_TYPE = gql`
  query GetMarkerCountByAccountIdAndType($accountId: Long!, $type: Int!) {
    countByAccountIdAndType(accountId: $accountId, type: $type)
  }
`;

export interface GetMarkerCountByAccountIdAndTypeResponse {
    countByAccountIdAndType: number;
}
